import { GenericLazyString, gettext } from '@eventbrite/i18n';
import React from 'react';
import { DiscountSignal } from './DiscountSignal';

import styles from './AggregatedDiscountSignals.module.scss';

const DiscountItem = ({
    children,
    className,
}: {
    children: React.ReactNode;
    className: string;
}) => {
    return <span className={className}>{children}</span>;
};

export const AggregatedDiscountSignals = ({
    discounts,
}: {
    discounts: Array<string | GenericLazyString>;
}) => {
    const discountsToShow =
        discounts.length > 2 ? [gettext('Discounts applied')] : discounts;

    return (
        <>
            <DiscountSignal className={styles['discount-signal']}>
                <div className={styles['discount-item-wrapper']}>
                    {discountsToShow.map((discount, index) => (
                        <React.Fragment key={discount.toString()}>
                            <DiscountItem className={styles['discount-item']}>
                                {discount.toString()}
                            </DiscountItem>
                            {index < discountsToShow.length - 1 ? (
                                <span className={styles['discount-divider']} />
                            ) : null}
                        </React.Fragment>
                    ))}
                </div>
            </DiscountSignal>
        </>
    );
};
